import React from 'react';
import s from './Layout.module.scss';
import { SurfaceColor } from 'common/components/utils.ts';

export type LayoutPresentationProps = {
  children: React.ReactNode;
  className?: string;
  bgColor?: SurfaceColor;
  style?: React.CSSProperties;
};

function Layout({ children, className = '', bgColor, style }: LayoutPresentationProps) {
  return (
    <div className={`${s.authenticatedLayout} ${className} bg-${bgColor}`} style={style}>
      {children}
    </div>
  );
}

export default Layout;
